





























































































































import { SharingRole, sp } from "@pnp/sp/presets/all";
import _ from "lodash";
import { Component, Vue, Watch } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import {
  GetGroupsResponse,
  GetUsersResponse,
  GroupsApi,
  UserModel,
  UsersApi,
} from "../../../apis";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import ConfirmDialog from "./ConfirmDialog.vue";
import InviteDialog from "./InviteDialog.vue";
import UserDetailDialog from "./UserDetailDialog.vue";

export interface SearchForm {
  text?: string;
  organization?: any;
  group?: any;
  status?: any;
}

@Component({
  components: { MoreVertBtn, InviteDialog, ConfirmDialog, UserDetailDialog },
})
export default class AdminUserManagement extends Vue {
  searchForm: SearchForm = {
    text: "",
    organization: null,
    group: null,
    status: null,
  };
  groupsResponse: GetGroupsResponse | null = null;
  usersResponse: GetUsersResponse | null = null;
  users: UserModel[] = [];
  selectedUser: UserModel | null = null;
  selectedAction: string = "";
  pagingOption: DataOptions | null = null;
  showDialog = false;
  showConfirmDialog = false;
  showUserDetailDialog = false;
  confirmContent = "";
  dialogType = "";

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  get inviteUserClick() {
    return this.$store.getters.inviteUserClick;
  }

  @Watch("inviteUserClick")
  onInviteUserClick() {
    this.showDialog = true;
    this.dialogType = "INVITE";
  }

  onPagingOption() {
    this.doSearch();
  }

  onClose() {
    this.doSearch();
  }

  async onOk() {
    // const loading = this.$loading.show();
    try {
      if (this.selectedAction === "RESET_PASSWORD") {
        this.resetPassword();
        return;
      }

      if (
        ["REMOVE", "DISABLE", "ENABLE", "REJECT"].indexOf(
          this.selectedAction
        ) !== -1
      ) {
        await new UsersApi().putDoUpdateUser({
          putUserRequest: {
            userId: this.selectedUser.id,
            action: this.selectedAction,
            groupIds: undefined,
          },
        });
      }

      if (this.selectedAction === "EDIT") {
        await new UsersApi().putDoUpdateUser({
          putUserRequest: {
            userId: this.selectedUser.id,
            action: this.selectedAction,
            groupIds: undefined,
          },
        });
      }
      this.doSearch();
    } finally {
      // loading.hide();
    }
  }

  onSelectedAction(val: { item: UserModel; action: string }) {
    this.selectedUser = val.item;
    this.selectedAction = val.action;

    if (val.action === "EDIT") {
      this.showUserDetailDialog = true;
    }
    if (val.action === "APPROVE") {
      this.showDialog = true;
      this.dialogType = "APPROVE";
    }
    if (val.action === "RESEND") {
      this.resend(val.item);
    }
    if (val.action === "REJECT") {
      this.showConfirmDialog = true;
      this.confirmContent = this.lodash.template(
        `${this.$t("dialog.reject.content")}`
      )({ user: this.selectedUser.email });
    }
    if (val.action === "DISABLE") {
      this.showConfirmDialog = true;
      this.confirmContent = this.lodash.template(
        `${this.$t("dialog.disable.content")}`
      )({ user: this.selectedUser.email });
    }
    if (val.action === "ENABLE") {
      this.showConfirmDialog = true;
      this.confirmContent = this.lodash.template(
        `${this.$t("dialog.enable.content")}`
      )({ user: this.selectedUser.email });
    }
    if (val.action === "REMOVE") {
      this.showConfirmDialog = true;
      this.confirmContent = this.lodash.template(
        `${this.$t("dialog.delete.content")}`
      )({ user: this.selectedUser.email });
    }
    if (val.action === "RESET_PASSWORD") {
      this.showConfirmDialog = true;
      this.confirmContent = this.lodash.template(
        `${this.$t("dialog.resetPassword.content")}`
      )({ user: this.selectedUser.email });
    }
  }

  get ACTIONS(): IAction[] {
    return [
      {
        titleName: this.$t("button.resendInvitation"),
        titleStyle: "color: black; font-weight: 600",
        action: "RESEND",
        permission: { context: "USER_MANAGEMENT", action: "update" },
        status: ["INVITED"],
      },
      {
        titleName: this.$t("button.approveUser"),
        titleStyle: "color: #00B162; font-weight: 600",
        action: "APPROVE",
        permission: { context: "USER_MANAGEMENT", action: "update" },
        status: ["NEW"],
      },
      {
        titleName: this.$t("button.rejectUser"),
        titleStyle: "color: red; font-weight: 600",
        action: "REJECT",
        permission: { context: "USER_MANAGEMENT|ACTIVATE_DEACTIVATE", action: "update" },
        status: ["NEW"],
      },
      {
        titleName: this.$t("button.diableUser"),
        titleStyle: "color: red; font-weight: 600",
        action: "DISABLE",
        permission: { context: "USER_MANAGEMENT", action: "update" },
        status: ["ACTIVE"],
      },
      {
        titleName: this.$t("button.enableUser"),
        titleStyle: "color: #027975; font-weight: 600",
        action: "ENABLE",
        permission: { context: "USER_MANAGEMENT", action: "update" },
        status: ["INACTIVE"],
      },
      {
        titleName: this.$t("button.editUser"),
        titleStyle: "color: black; font-weight: 600",
        action: "EDIT",
        permission: { context: "USER_MANAGEMENT", action: "update" },
        status: ["INACTIVE", "ACTIVE", "INVITED"],
      },
      {
        titleName: this.$t("button.removeUser"),
        titleStyle: "color: red; font-weight: 600",
        action: "REMOVE",
        permission: { context: "USER_MANAGEMENT|ACTIVATE_DEACTIVATE", action: "delete" },
        status: ["INACTIVE", "ACTIVE", "INVITED"],
      },
      {
        titleName: this.$t("text.reset-password"),
        titleStyle: "color: black; font-weight: 600",
        action: "RESET_PASSWORD",
        status: ["ACTIVE"],
      },
    ];
  }

  async resetPassword() {
    try {
      this.$util.showLoading();
      const result = await new UsersApi().forgotPassword({
        postForgotPasswordRequest: {
          email: this.selectedUser.email,
        },
      });
      if (result.status === 200) {
        console.log(result);
      } else {
        this.$util.showError(this.$t("dialog.resetPassword.error"));
      }
    } catch(err) {
      this.$util.showError(err);
    } finally {
      this.$util.hideLoading();
    }
  }

  beforeCreate() {
    new GroupsApi().getGroups().then((val) => {
      this.groupsResponse = val.data;
    });
  }

  mounted() {
    const user = this.me;
    new UsersApi().putDoSyncUser({
      id: user.id,
      putSpUser: {
        fullName: user.fullName,
        spId: user.email,
      },
    }).catch((error) => {
      this.$util.showError(error);
    });
  }

  get ORGANIZATIONS() {
    return [
      { value: "ECO2", text: this.$t("page.user.organization.ECO2") },
      { value: "CLIENT", text: this.$t("page.user.organization.CLIENT") },
    ];
  }

  get STATUS() {
    return [
      { value: "NEW", text: this.$t("page.user.status.NEW") },
      { value: "ACTIVE", text: this.$t("page.user.status.ACTIVE") },
      { value: "INACTIVE", text: this.$t("page.user.status.INACTIVE") },
      { value: "INVITED", text: this.$t("page.user.status.INVITED") },
    ];
  }

  get GROUPS() {
    if (!this.groupsResponse) {
      return [];
    }
    return this.groupsResponse.data.map((val) => ({
      value: val.id,
      text: val.name,
    }));
  }

  get HEADERS() {
    const user: UserModel = this.$store.getters.user;
    if (user.organization === "CLIENT") {
      return [
        {
          text: this.$t("text.profileImage"),
          value: "img",
          sortable: false,
          align: "center",
        },
        { text: this.$t("text.fullName"), value: "fullName", width: 200 },
        { text: this.$t("text.email"), value: "email" },
        { text: this.$t("text.createdDate"), value: "createdDate", width: 150 },
        { text: this.$t("text.status"), value: "status", align: "start" },
        { text: this.$t("text.action"), value: "action", sortable: false }
      ] as DataTableHeader[];
    }
    return [
      {
        text: this.$t("text.profileImage"),
        value: "img",
        sortable: false,
        width: 120,
        align: "center",
      },
      { text: this.$t("text.fullName"), value: "fullName", width: 200 },
      { text: this.$t("text.email"), value: "email" },
      { text: this.$t("text.group"), value: "group", sortable: false },
      { text: this.$t("text.organization"), value: "organization", width: 150 },
      { text: this.$t("text.createdDate"), value: "createdDate", width: 150 },
      { text: this.$t("text.status"), value: "status", align: "start" },
      { text: this.$t("text.action"), value: "action", sortable: false },
    ] as DataTableHeader[];
  }

  async doSearch(isResetPage = false) {
    if (isResetPage && this.pagingOption.page !== 1) {
      this.pagingOption.page = 1;
      return;
    }
    this.$util.showLoading();
    try {
      const rs = await new UsersApi().getUsers({
        page: this.pagingOption.page,
        limit: this.pagingOption.itemsPerPage,
        searchText: this.searchForm.text,
        organization: this.searchForm.organization
          ? this.searchForm.organization.value
          : undefined,
        group: this.searchForm.group ? this.searchForm.group.value : undefined,
        status: this.searchForm.status
          ? this.searchForm.status.value
          : undefined,
        orderBy:
          this.pagingOption.sortBy.length > 0
            ? this.pagingOption.sortBy[0]
            : undefined,
        orderDesc:
          this.pagingOption.sortDesc.length > 0
            ? "" + this.pagingOption.sortDesc[0]
            : undefined,
      });
      this.usersResponse = rs.data;
      this.users = rs.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      // loading.hide();
      this.$util.hideLoading();
    }
  }

  toGroup(user: UserModel) {
    if (!user.groups) return "";
    return _.join(
      user.groups.map((val) => val.name),
      ", "
    );
  }

  get me() {
    return this.$store.getters.user as UserModel;
  }

  getAction(user: UserModel) {
    return _.filter(
      this.me.id === user.id
        ? this.ACTIONS.filter((a) => a.action !== "REMOVE")
        : this.ACTIONS,
      (val) => val.status.indexOf(user.status) >= 0
    );
  }

  async resend(user: UserModel) {
    // const loading = this.$loading.show();
    this.$util.showLoading();
    try {
      await new UsersApi().resendInvitation({
        postResendInvitationRequest: {
          email: user.email,
        },
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  getColor(status: string) {
    let color = "#00B162";
    switch (status) {
      case "NEW":
        color = "#FFB83D";
        break;
      case "INVITED":
        color = "#000000";
        break;
      case "APPROVED":
        color = "#FFB83D";
        break;
      case "INACTIVE":
        color = "#8A8A8A";
        break;
      default:
        break;
    }
    return color;
  }
}
